import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"

import MetaTags from "react-meta-tags"
import { useSelector, useDispatch } from "react-redux"

import { Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import { getData, options } from "./data"
import { FiltersCard } from "components/Common/FiltersCard"
import Table from "./Table"
import { getAllSuppliers } from "store/suppliers/actions"
import { mapDataForDropDown } from "../../../helpers/helpers"
import moment from "moment";
import {sitename} from "../../../constants/constants";

const SuppliersReport = props => {
  const dispatch = useDispatch()
  const Suppliers = useSelector(state => state.suppliers.Index ?? [])
  const [item, setItem] = useState("")
  const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"))
  const [fromDate, setFromDate] = useState(moment().format("YYYY-MM-DD"))

  useEffect(() => {
    dispatch(getAllSuppliers())
  }, [])
  useEffect(() => {
    let df = Suppliers[0]?.name
    setItem(df)
  }, [Suppliers])

  return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>{sitename}</title>
          </MetaTags>
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs title="Admin" breadcrumbItem="Suppliers Report" />
          </Container>
          <FiltersCard
              toDate={toDate}
              fromDate={fromDate}
              setToDate={d => setToDate(d)}
              setFromDate={d => setFromDate(d)}
              item={item}
              setItem={setItem}
              options={mapDataForDropDown(Suppliers)}
              filterLabel={"Suppliers"}
              hideShowType={false}
          />
          <Table data={getData()} />
        </div>
      </React.Fragment>
  )
}

export default withRouter(SuppliersReport)
